var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupDarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.343,
    height: 18,
    viewBox: "0 0 18.343 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160666",
    "data-name": "Group 160666",
    transform: "translate(-408.337 -320)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160592",
    "data-name": "Group 160592",
    transform: "translate(408.421 320)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1058",
    "data-name": "Path 1058",
    d: "M16.256,18.084v.08a9.878,9.878,0,0,1-10.036,0v-.089a5.026,5.026,0,0,1,9.411-2.385",
    transform: "translate(-2.238 -2.921)",
    fill: "#adc7ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160582",
    "data-name": "Group 160582"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_965",
    width: 18,
    height: 18,
    fill: "rgba(255,225,225,0)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_140",
    "data-name": "Ellipse 140",
    cx: 0.498,
    cy: 0.498,
    r: 0.498,
    transform: "translate(10.273 1.681)",
    fill: "#165cf3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1066",
    "data-name": "Path 1066",
    d: "M17.882,17.872q.328.026.656.026a7.821,7.821,0,0,0,2.614-.446,1.684,1.684,0,0,1,.009-.21,2.624,2.624,0,0,0-4.1-2.168",
    transform: "translate(-3.65 -3.296)",
    fill: "#f49b31",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    "data-name": "Path 1067",
    d: "M6.35,15.075a2.622,2.622,0,0,0-4.1,2.168v.21a7.821,7.821,0,0,0,2.614.446q.328,0,.656-.026",
    transform: "translate(-1.583 -3.296)",
    fill: "#f49b31",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3239",
    "data-name": "Group 3239",
    transform: "translate(3.832 9.309)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1068",
    "data-name": "Path 1068",
    d: "M16.488,18v.332a4.476,4.476,0,0,1-.035.586,10.519,10.519,0,0,1-10.428,0c-.017-.192-.035-.393-.035-.586V18",
    transform: "translate(-5.99 -13.078)",
    fill: "#adc7ff",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    d: "M17.882,17.937a5.223,5.223,0,0,0-.822-2.8",
    transform: "translate(-7.383 -12.718)",
    fill: "#adc7ff",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1070",
    "data-name": "Path 1070",
    d: "M15.786,14.791a5.247,5.247,0,0,0-8.846,0",
    transform: "translate(-6.11 -12.369)",
    fill: "#adc7ff",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    d: "M6.822,15.14A5.223,5.223,0,0,0,6,17.937",
    transform: "translate(-5.991 -12.718)",
    fill: "#adc7ff",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1072",
    "data-name": "Path 1072",
    d: "M14.192,5.468a2.668,2.668,0,0,1,.052.524A2.622,2.622,0,1,1,11.622,3.37",
    transform: "translate(-2.536 -1.724)",
    fill: "#adc7ff",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_141",
    "data-name": "Ellipse 141",
    cx: 1.967,
    cy: 1.967,
    r: 1.967,
    transform: "translate(12.92 4.862)",
    fill: "#f49b31",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_142",
    "data-name": "Ellipse 142",
    cx: 1.967,
    cy: 1.967,
    r: 1.967,
    transform: "translate(1.322 4.862)",
    fill: "#f49b31",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupDarkIcon);
export default __webpack_public_path__ + "static/media/group-dark-icon.15bf3fc06591040beb76165043abcac6.svg";
export { ForwardRef as ReactComponent };